import { SvgIcon, SvgIconProps } from '@mui/material';

const SponsorshipCampaignIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns='http://www.w3.org/2000/svg' width='19' height='24' viewBox='0 0 19 24' fill='none'>
        <path
          d='M18 10.7778V7C18 4.17157 18 2.75736 17.1213 1.87868C16.2426 1 14.8284 1 12 1H7C4.17157 1 2.75736 1 1.87868 1.87868C1 2.75736 1 4.17157 1 7V17C1 19.8284 1 21.2426 1.87868 22.1213C2.75736 23 4.17157 23 7 23H9.5'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <circle cx='10' cy='10' r='3.25' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
        <path
          d='M3.53183 21.4963C3.67347 18.1376 6.51545 16.3955 9.87718 16.3955H11.3118C14.1356 16.3955 16.8447 17.9086 17.3076 20.6942C17.3764 21.1079 17.4305 21.5444 17.4636 22.0004C17.5036 22.5512 17.0523 23 16.5 23H4.40198C3.90383 23 3.51084 21.9941 3.53183 21.4963V21.4963Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </svg>
    </SvgIcon>
  );
};

export default SponsorshipCampaignIcon;
